import { useEffect } from "react"
import { mutate } from "swr"

const VIEWABLE_KEY_PREFIXES = {
  ViewGroup: "view_groups",
  View: "views",
}

export default function useViewableInvalidation() {
  useEffect(() => {
    function revalidate({ detail }) {
      const prefix = VIEWABLE_KEY_PREFIXES[detail.viewableType]
      if (prefix) mutate(`${prefix}/${detail.viewableId}`)
    }

    document.addEventListener(
      "event-dispatcher:viewable-invalidated",
      revalidate
    )
    return () =>
      document.removeEventListener(
        "event-dispatcher:viewable-invalidated",
        revalidate
      )
  }, [])
}
